"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _usePropTypes = require("./usePropTypes");

var _useEffectSkipMount = _interopRequireDefault(require("./useEffectSkipMount"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useToggle = function useToggle(props) {
  var newProps = (0, _react.useCallback)(function () {
    return (0, _usePropTypes.useComponentPropTypes)(useToggle, props);
  }, [props])();

  var _useState = (0, _react.useState)(newProps.active),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      evt = _useState4[0],
      setEvt = _useState4[1];

  (0, _useEffectSkipMount.default)(function () {
    if (active) {
      newProps.onToggleOn(evt, {
        name: newProps.name,
        value: active
      });
    } else {
      newProps.onToggleOff(evt, {
        name: newProps.name,
        value: active
      });
    }

    newProps.onToggle(evt, {
      name: newProps.name,
      value: active
    });
  }, [active]);
  var toggleOn = (0, _react.useCallback)(function (e) {
    setEvt(e);
    setActive(true);
  }, []);
  var toggleOff = (0, _react.useCallback)(function (e) {
    setEvt(e);
    setActive(false);
  }, []);
  var toggle = active ? function (e) {
    return toggleOff(e);
  } : function (e) {
    return toggleOn(e);
  };
  return {
    toggleOn: toggleOn,
    toggleOff: toggleOff,
    toggle: toggle,
    active: active
  };
};

useToggle.propTypes = {
  name: _propTypes.default.string,
  active: _propTypes.default.bool,
  onToggleOn: _propTypes.default.func,
  onToggleOff: _propTypes.default.func,
  onToggle: _propTypes.default.func
};
useToggle.defaultProps = {
  name: null,
  active: false,
  onToggleOn: function onToggleOn() {},
  onToggleOff: function onToggleOff() {},
  onToggle: function onToggle() {}
};
var _default = useToggle;
exports.default = _default;